<div id="map" style="height: 500px; width: 100%;" leaflet [leafletOptions]="options2"
    (leafletMapReady)="onMapReady($event)" (leafletClick)="mapClicked($event)">
</div>